export const redirect = (url: string) => {
  window.location.href = url
}

export const search = () => window.location.search

export const pathname = () => window.location.pathname
